import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    selectedBookie: "Odibets",
    filter: "Unchecked",
    filter2: "Unchecked",
  },
  mutations: {
    setSelectedBookie(state, bookie) {
      state.selectedBookie = bookie;
    },
    setFilter(state, filter) {
      state.filter = filter;
    },
    setFilter2(state, filter2) {
      state.filter2 = filter2;
    }
  },
  actions: {
    setSelectedBookie({ commit }, bookie) {
      commit("setSelectedBookie", bookie);
    },
    setFilter({ commit }, filter) {
      commit("setFilter", filter);
    },
    setFilter2({ commit }, filter2) {
      commit("setFilter2", filter2);
    }
  },
  getters: {
    selectedBookie: state => state.selectedBookie,
    filter: state => state.filter,
    filter2: state => state.filter2
  },
  modules: {}
});
